import { render, staticRenderFns } from "./ClientGroupsList.vue?vue&type=template&id=d517f19a&scoped=true&"
import script from "./ClientGroupsList.vue?vue&type=script&lang=js&"
export * from "./ClientGroupsList.vue?vue&type=script&lang=js&"
import style0 from "./ClientGroupsList.vue?vue&type=style&index=0&id=d517f19a&lang=scss&scoped=true&"
import style1 from "./ClientGroupsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d517f19a",
  null
  
)

export default component.exports